import React from 'react';
import { spinner } from '../styles/spinner.module.scss';

const Spinner = ({ colour='white' }) => {
  return <div className={ spinner } style={{ borderTopColor: `${colour}` }} />
};

export default Spinner;